import { settings } from '@/main/config/settings'
import { Location, NavigateFunction } from 'react-router-dom'

export enum WINDOW_TARGET {
  BLANK = '_blank',
  SELF = '_self'
}

export enum WINDOW_REL {
  NO = 'noopener noreferrer'
}

export const SCROLL_TOP_PARAMS: ScrollToOptions = {
  top: 0,
  left: 0,
  behavior: 'smooth'
}

export const getGoBackPath = (
  location: Location,
  navigate: NavigateFunction,
  defaultPath: string = '/'
): void => {
  if (location.key === 'default') {
    navigate(defaultPath)
  } else {
    navigate(-1)
  }
}

export const redirectTo = (url: string, target?: string, opener = false) => {
  window.open(url, target || WINDOW_TARGET.SELF, opener ? undefined : 'noopener noreferrer')
}

export const redirectToSupport = () => {
  redirectTo(settings.SUPPORT_URL, WINDOW_TARGET.BLANK)
}

export const redirectToTermsOfUse = () => {
  redirectTo(settings.SKILL_TERMS_OF_USE_URL, WINDOW_TARGET.BLANK)
}

export const redirectToPrivacyPolicy = () => {
  redirectTo(settings.SKILL_PRIVACY_POLICY_URL, WINDOW_TARGET.BLANK)
}

export const reloadPage = (removeParams?: boolean) => {
  if (removeParams) {
    redirectTo(`${window.location.origin}${window.location.pathname}`, WINDOW_TARGET.SELF)
  } else {
    window.location.reload()
  }
}

export const clearHashParams = (url?: string | URL) => {
  const uri = new URL(url || window.location.href).href
  if (uri.indexOf('#') > 0) {
    const cleanUri = uri.substring(0, uri.indexOf('#'))
    window.history.replaceState({}, document.title, cleanUri)
  }
}

export const historyStateUrl = (
  searchParams: URLSearchParams,
  url: string | undefined,
  action: 'push' | 'replace' = 'replace'
) => {
  if (!url) {
    url = `${window.location.origin}${window.location.pathname}`
    url += searchParams.size ? `?${searchParams}` : ''
  }
  if (action === 'push') {
    window.history.pushState({ path: url }, '', url)
  } else {
    window.history.replaceState({ path: url }, '', url)
  }
}

export const historyStateParams = (params?: Record<string, string | undefined | null>) => {
  const cleanParams: Record<string, string> = {}
  Object.entries(params ?? {})
    .filter(([, value]) => !!value)
    .forEach(([key, value]) => (cleanParams[key] = value!))

  const searchParams = new URLSearchParams(cleanParams)
  historyStateUrl(searchParams, undefined, 'replace')
}
